import React from 'react';
import clsx from 'clsx';

export default function FieldErrors({ errors, className }) {
    const uniqueErrors = errors.toOrderedSet().toList();
    if (!uniqueErrors.size) {
        return null;
    }
    return (
        <div className={clsx('nike-input-error', className)}>
            {uniqueErrors.map((error, i) => (
                <span className="input-error" key={i}>
                    {error}
                </span>
            ))}
        </div>
    );
}
